<div class="root">
	@for (menuItem of appMenuService.topLevelMenu(); track menuItem.name) {
		@if (menuItem.subMenus) {
			<div (mouseenter)="openIfHorizontal(menuItem.name)" (mouseleave)="closeIfHorizontal(menuItem.name)">
				<a
					class="root-item"
					[routerLink]="getUrl(menuItem)"
					[queryParams]="menuItem.queryParams"
					[queryParamsHandling]="menuItem.queryParamsHandling"
					[class.ingeklapt]="openSubMenu !== menuItem.name"
					[class.uitgeklapt]="openSubMenu === menuItem.name"
					routerLinkActive="active"
					(click)="trackNavigation(menuItem)"
				>
					<span (click)="toggle(menuItem.name, $event)">
						@if (vertical) {
							<app-icon
								[name]="openSubMenu === menuItem.name ? 'chevron-down' : 'chevron-right'"
								size="small"
								color="typography-4"
							></app-icon>
						}
						{{ menuItem.name }}
					</span>
				</a>
				<div class="sub">
					@for (subMenuItem of menuItem.subMenus; track subMenuItem.name) {
						<a
							class="sub-item"
							[routerLink]="getUrl(subMenuItem)"
							[queryParams]="subMenuItem.queryParams"
							[queryParamsHandling]="subMenuItem.queryParamsHandling"
							routerLinkActive="active"
							(click)="trackNavigation(subMenuItem)"
						>
							{{ subMenuItem.name }}
						</a>
					}
				</div>
			</div>
		} @else {
			<a
				class="root-item"
				[routerLink]="getUrl(menuItem)"
				[queryParams]="menuItem.queryParams"
				[queryParamsHandling]="menuItem.queryParamsHandling"
				routerLinkActive="active"
				(click)="trackNavigation(menuItem)"
			>
				{{ menuItem.name }}
			</a>
		}
	}
</div>
